const { h, render, Component } = require('preact');

class SingleActionSSAView extends Component {
  constructor(props) {
    super(props);
    this.getSSA = this.getSSA.bind(this);
  }

  getSSA() {
    let rel = "noopener noreferrer";
    let target = "_blank";
    if (this.props.SSAType === "refund_request") {
      rel = "";
      target = "";
    }
    var seperator = "| "

    if (this.props.firstSSA) {
      seperator = ""
    }

    if (this.props.landingView) {
      return (

          <span>{seperator}
          <a href={this.props.SSADetails.UrlForSSA} rel={rel} target={target}
             data-bhw={("web2018_ssa_" + this.props.SSADetails.SSAText).replace(' ', '_') +"__"+ (this.props.orderDetails? this.props.orderDetails.id : null)}>
            {this.props.SSADetails.SSAText}
          </a>
          </span>
      )
    }
    else {
      return (
          <a href={this.props.SSADetails.UrlForSSA} class="btn-invert ssa-button" rel={rel} target={target}
             data-bhw={("web2018_ssa_" + this.props.SSADetails.SSAText).replace(' ', '_')}>
            {this.props.SSADetails.SSAText}
            {(this.props.SSADetails.SSASubText) && <div class="ssa-subtext">{this.props.SSADetails.SSASubText}</div>}
          </a>
      )
    }
  }

  render() {
    if (this.props.landingView) {
     return( <div className="ssa-holder-landing">
        {this.getSSA()}
      </div>
     )
    }
    else {
      return (
          <div class="ssa-holder">
            {this.getSSA()}
          </div>
      );
    }
  }
}
module.exports = SingleActionSSAView
